export enum RestCallType {
	GET = 'GET',
	POST = 'POST',
	PATCH = 'PATCH',
	OPTIONS = 'OPTIONS',
	DELETE = 'DELETE',
}
